export const formatearMonto = (valor) => {
  const numero = Number(valor || 0);
  if (isNaN(numero)) {
    return "S/ 0.00";
  }
  return `S/ ${numero.toFixed(2)}`;
};

export const getSistemaPensionMonto = (detalle) => {
  if (!detalle?.descuentos?.sistema_pension) return "S/ 0.00";

  const { sistema_pension } = detalle.descuentos;

  if (sistema_pension.onp) {
    return formatearMonto(sistema_pension.onp);
  }

  return formatearMonto(sistema_pension.fondo);
};

export const getTotalColumna = (detalles, path) => {
  return detalles.reduce((acc, det) => {
    const valor = path.split(".").reduce((obj, key) => obj?.[key], det) || 0;
    return acc + Number(valor);
  }, 0);
};